import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Table, Drawer } from "antd";
import { getInvoicePayments } from "./../../actions/invoicepayments";
import PaymentMemo from "./PaymentMemo";

const PaymentHistory = ({ getInvoicePayments, details }) => {
  const [loading, setloading] = useState(true);
  const [payments, setpayments] = useState([]);
  const [visible, setVisible] = useState(false);

  const showDrawer = () => {
    getInvoicePayments(details.id).then((res) => {
      if (res.count > 0) {
        setpayments(res.results);
        setVisible(true);
      } else {
        setVisible(true);
      }
    });
  };

  const onClose = () => {
    setVisible(false);
  };

  const columns = [
    {
      title: "Issue Date",
      dataIndex: "issue_date",
      key: "issue_date",
    },
    {
      title: "Bill",
      dataIndex: "bill",
      key: "bill",
    },
    {
      title: "Advance",
      dataIndex: "advance_payment",
      key: "advance_payment",
    },
    {
      title: "Payment",
      dataIndex: "payment",
      key: "payment",
    },
    {
      title: "Due",
      dataIndex: "due",
      key: "due",
    },

    {
      title: "Action",
      dataIndex: "",
      key: "x",
      align: "center",

      render: (data) => {
        return (
          <>
            <PaymentMemo details={details} paymentmemo={data} />
          </>
        );
      },
    },
  ];

  const renderdata = () => {
    return <Table columns={columns} dataSource={payments} />;
  };

  return (
    <>
      <a href="#" onClick={showDrawer} style={{ margin: 4 }}>
        Payments
      </a>
      <Drawer
        width="40%"
        onClose={onClose}
        visible={visible}
        placement="right"
        bodyStyle={{ margin: 0 }}
      >
        {renderdata()}
      </Drawer>
    </>
  );
};

export default connect(null, {
  getInvoicePayments,
})(PaymentHistory);
